// src/app/modules/ThreatAlerts/database/column-formatters/DateFormatter.jsx
import React from "react";
import Moment from "moment";

export function DateFormatter(cellContent, row) {
  if (!row.created_at) {
    return <span className="sety-tbl-sub">—</span>;
  }

  const date = Moment(row.created_at);
  const isRecent = Moment().diff(date, 'hours') <= 24;

  return (
    <div>
      <div style={{ fontWeight: 600, fontSize: 13.5 }}>{date.format('MMM DD, YYYY')}</div>
      <div className="sety-tbl-sub" style={{ color: isRecent ? 'var(--red)' : undefined }}>
        {date.fromNow()}
      </div>
    </div>
  );
}
